import { render, staticRenderFns } from "./companyworkweeks-add-or-update.vue?vue&type=template&id=5e68ade4&"
import script from "./companyworkweeks-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companyworkweeks-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports